"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapCatch = exports.parseJson = void 0;

var wrapCatch = function wrapCatch(func) {
  var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function () {
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return func.apply(null, args);
    } catch (err) {
      return fallbackValue;
    }
  };
};

exports.wrapCatch = wrapCatch;
var parseJson = wrapCatch(function (data) {
  return typeof data === 'string' ? JSON.parse(data) : data;
});
exports.parseJson = parseJson;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob2Yvd3JhcC1jYXRjaC50cyJdLCJuYW1lcyI6WyJ3cmFwQ2F0Y2giLCJmdW5jIiwiZmFsbGJhY2tWYWx1ZSIsImFyZ3MiLCJhcHBseSIsImVyciIsInBhcnNlSnNvbiIsImRhdGEiLCJKU09OIiwicGFyc2UiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFTyxJQUFNQSxTQUFTLEdBQUcsU0FBWkEsU0FBWSxDQUFDQyxJQUFEO0FBQUEsTUFBbUJDLGFBQW5CLHVFQUF3QyxJQUF4QztBQUFBLFNBQWlELFlBQWE7QUFDckYsUUFBSTtBQUFBLHdDQUR3RUMsSUFDeEU7QUFEd0VBLFFBQUFBLElBQ3hFO0FBQUE7O0FBQ0YsYUFBT0YsSUFBSSxDQUFDRyxLQUFMLENBQVcsSUFBWCxFQUFpQkQsSUFBakIsQ0FBUDtBQUNELEtBRkQsQ0FFRSxPQUFPRSxHQUFQLEVBQVk7QUFDWixhQUFPSCxhQUFQO0FBQ0Q7QUFDRixHQU53QjtBQUFBLENBQWxCOzs7QUFRQSxJQUFNSSxTQUFTLEdBQUdOLFNBQVMsQ0FBQyxVQUFBTyxJQUFJO0FBQUEsU0FBSyxPQUFPQSxJQUFQLEtBQWdCLFFBQWhCLEdBQTJCQyxJQUFJLENBQUNDLEtBQUwsQ0FBV0YsSUFBWCxDQUEzQixHQUE4Q0EsSUFBbkQ7QUFBQSxDQUFMLENBQTNCIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHR5cGUgVHlwZUZhY3RvciA9ICguLi5hcmdzKSA9PiBhbnlcblxuZXhwb3J0IGNvbnN0IHdyYXBDYXRjaCA9IChmdW5jOiBUeXBlRmFjdG9yLCBmYWxsYmFja1ZhbHVlOiBhbnkgPSBudWxsKSA9PiAoLi4uYXJncykgPT4ge1xuICB0cnkge1xuICAgIHJldHVybiBmdW5jLmFwcGx5KG51bGwsIGFyZ3MpO1xuICB9IGNhdGNoIChlcnIpIHtcbiAgICByZXR1cm4gZmFsbGJhY2tWYWx1ZTtcbiAgfVxufTtcblxuZXhwb3J0IGNvbnN0IHBhcnNlSnNvbiA9IHdyYXBDYXRjaChkYXRhID0+ICh0eXBlb2YgZGF0YSA9PT0gJ3N0cmluZycgPyBKU09OLnBhcnNlKGRhdGEpIDogZGF0YSkpO1xuIl19